import React, { useState, Fragment, useContext, createContext } from 'react';
import { SimpleModal } from 'components';

export const TertiaryModalModalContext = createContext(null);

export const TertiaryModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState('');
  const [params, setParams] = useState({});
  return (
    <Fragment>
      <TertiaryModalModalContext.Provider
        value={{
          activeModal,
          setActiveModal,
          params,
          setParams,
        }}>
        {children}
      </TertiaryModalModalContext.Provider>
    </Fragment>
  );
};
export const useTertiaryModal = () => {
  const { setActiveModal, params, setParams } = useContext(TertiaryModalModalContext);
  return {
    openTertiary: (params = {}) => {
      setActiveModal(true);
      setParams(params);
    },
    closeTertiary: () => {
      setActiveModal('');
      setParams({});
    },
    params,
  };
};
export const TertiaryModal = () => {
  const { activeModal } = useContext(TertiaryModalModalContext);
  const { closeTertiary, params } = useTertiaryModal();
  return (
    <SimpleModal
      handleOpenClose={closeTertiary}
      openDefault={activeModal ? activeModal : false}
      content={
        <div style={{ outline: 'none' }} className="modal-wrapper-style">
          {/*<div className='modal-header-style'>*/}
          {/*  <CloseButton handleCLic={closePrimary}/>*/}
          {/*</div>*/}
          <div className="load-modal-body-style">
            {params}
          </div>
        </div>
      }
    />
  );
};